import { render } from "./CardEighteen.vue?vue&type=template&id=8e4fae6c"
import script from "./CardEighteen.vue?vue&type=script&lang=js"
export * from "./CardEighteen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__